import { render, staticRenderFns } from "./productbrand.vue?vue&type=template&id=e261bc0c&scoped=true&"
import script from "./productbrand.vue?vue&type=script&lang=js&"
export * from "./productbrand.vue?vue&type=script&lang=js&"
import style0 from "./productbrand.vue?vue&type=style&index=0&id=e261bc0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e261bc0c",
  null
  
)

export default component.exports